import { createSelector } from '@ngrx/store';
import { MessageStatus } from 'src/graphql/generated/graphql.generated';
import { selectAllMessageStatusUpdates } from './entity-store-selectors';

export function selectMessageStatusUpdateById(messageStatusUpdateId: string) {
  return createSelector(selectAllMessageStatusUpdates, (recipients) =>
    recipients.get(messageStatusUpdateId),
  );
}

export function selectMessageStatusUpdatesByMessageId(messageId: string) {
  return createSelector(selectAllMessageStatusUpdates, (messageUpdates) => {
    return messageUpdates
      .filter((r) => r.trackedMessageId === messageId)
      .toIndexedSeq()
      .sortBy((n) => n.dateCreated);
  });
}

export function selectErrorMessageByMessageId(messageId: string) {
  return createSelector(selectMessageStatusUpdatesByMessageId(messageId), (messageUpdates) => {
    return messageUpdates.filter((r) => r.status === MessageStatus.Failed).first(undefined);
  });
}
